export enum VehicleCategoryTypes {
  TRUCK_2000KG = 'TRUCK_2000KG',
  TRUCK_4000KG = 'TRUCK_4000KG',
  TRUCK_10000KG = 'TRUCK_10000KG',
  TRUCK_18000KG = 'TRUCK_18000KG',
  TRUCK_40000KG = 'TRUCK_40000KG',
  TRUCK_OVER_40000KG = 'TRUCK_OVER_40000KG'
}

export enum ContainerTypes {
  SEPARATED_CONTAINER = 'SEPARATED_CONTAINER',
  STICKY_CONTAINER = 'STICKY_CONTAINER'
}

export enum CoveringContainerLevel {
  PRIVATE = 'PRIVATE',
  OPEN = 'OPEN',
  EMPTY = ''
}

export enum GoodsTypes {
  LIQUID = 'LIQUID',
  SOLID = 'SOLID',
  GAS = 'GAS',
  EMPTY = ''
}

export enum PluginType {
  MOOC = 'MOOC',
  OIL = 'OIL',
  WHEEL = 'WHEEL',
  GENERATOR = 'GENERATOR',
  CONTAINER = 'CONTAINER',
  CHARGE = 'CHARGE'
}

export interface ITollStation {
  calculatedBy: string
  from: string
  to: string
  tollStation: string
  tollStationName: string
  tollStationDetail?: any
}

export interface IVehicleDocument {
  document: string | null
  fileName: string | null
  type: string | null
  privacy: string | null
  description: string | null
  expiredDate: string | null
  insurancePrice: number | null
}
export interface IMaintenance {
  from: Number
  to: Number
  value: Number
}

export interface IVehicleCategory {
  name: String
  from: Number | undefined
  to: Number | undefined
  wheelNumber: Number | undefined
  priceTires: Number | undefined
  depreciationTires: Number | undefined
  repairingPrice: Number | undefined
  description: String
}

export interface IVehicle {
  _id?: String | string
  name?: String
  code: String
  fleetVehicle: string | null
  nameFleetVehicle: string | null
  licensePlate: String
  price: Number | null
  driver: String | null
  driverName: String
  coDriver: String | null
  coDriverName: String
  wattage: Number | null
  weight: Number | null
  numberOfCharge: Number | null
  wheel: Number | null
  vehicleLoad: number | null
  manufacture: String
  manufactureYear: Number | null
  manufactureAt: String
  buyingTime: Number | null
  expiredYear: Number | null
  vehicleType: String | null
  fuelVolume: Number | null
  oilVolume: Number | null
  registry: Date | String
  maintenanceSchedule: Array<IMaintenance>
  status: String
  type: number | null
  insurance: String
  fuelConsumption: Number | null
  sellingPrice: Number | null
  repairingPrice: Number | null
  depreciationVehicle: Number | null
  createdAt?: Date
  updatedAt?: Date
  vehicleTypeDetail: { [key: string]: any }
  driverDetail: { [key: string]: any }
  isGenset: Boolean | null
  containerType: Boolean | null
  coveringContainerLevel: String
  goodsType: Array<GoodsTypes> | Array<String> | []
  licenseType: String | string | null
  tollStation: Array<string | any>
  priceLiquidation: null | number
  typeFleetVehicle: Array<string> | null
  fleetVehicleDetail?: { [key: string]: any } | [] | null
  otherCompanyDriver?: {
    fullName: string
    phone: {
      countryCode: string
      phone: string
      code: string
    }
    idCardNumber: string
  }
  approvedByManagement?: boolean | null | undefined
  parkingNodeId?: string | null
  parkingNodeName?: string | null
  parkingNodeLocationId?: string | null
  scheduleTimes?: any
  gpsTrackingType?: string
}

const initFormVehicle = {
  name: '',
  code: '',
  licensePlate: '',
  fleetVehicle: null,
  nameFleetVehicle: null,
  price: null,
  driver: null,
  driverName: '',
  coDriver: null,
  coDriverName: '',
  wattage: null,
  weight: null,
  numberOfCharge: null,
  wheel: null,
  vehicleLoad: null,
  manufacture: '',
  manufactureYear: null,
  manufactureAt: '',
  buyingTime: null,
  expiredYear: null,
  vehicleType: null,
  fuelVolume: null,
  oilVolume: null,
  registry: '',
  status: '',
  insurance: '',
  fuelConsumption: null,
  sellingPrice: null,
  repairingPrice: null,
  depreciationVehicle: null,
  vehicleTypeDetail: {} as { [key: string]: any },
  driverDetail: {} as { [key: string]: any },
  type: 0,
  isGenset: false,
  containerType: false,
  coveringContainerLevel: '',
  licenseType: '',
  maintenanceSchedule: [],
  tollStation: [] as Array<{ [key: string]: any }>,
  goodsType: ['SOLID'],
  priceLiquidation: null,
  typeFleetVehicle: null,
  otherCompanyDriver: {
    fullName: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    idCardNumber: ''
  },
  parkingNodeId: null,
  parkingNodeName: null,
  parkingNodeLocationId: null,
  gpsTrackingType: ''
}

const initVehicleCategory = {
  name: '',
  from: 0,
  to: null,
  wheelNumber: undefined,
  priceTires: undefined,
  depreciationTires: undefined,
  repairingPrice: undefined,
  liquidationValue: null,
  oilMaterialAssumption: null,
  description: ''
}

const initMaintenance = {
  from: 0,
  to: 0,
  value: 0
}
const initTollStationPrice = {
  tollStation: '',
  from: '',
  to: '',
  calculatedBy: null,
  tollStationName: ''
}

const rules = {
  addVehicleCategory: {
    'vehicleModule.category.categoryName': 'required',
    fromKg: 'required|integer',
    toKg: 'integer',
    'vehicleModule.category.wheelNumber': 'required|integer|min_value:1',
    'vehicleModule.category.priceTires': 'required',
    'vehicleModule.category.depreciationTires': 'required|integer|min_value:1',
    liquidationValue: 'required|integer|min_value:1',
    oilMaterialAssumption: 'required|gt:0',
    'vehicleModule.repairingPrice': 'required'
  },
  addVehicle: {
    'vehicleModule.licensePlate': 'required',
    'vehicleModule.price': 'integer',
    'vehicleModule.weight': 'integer',
    'driverModule.licenseType': '',
    'vehicleModule.buyingTime': 'integer|min_value:1970',
    'vehicleModule.expiredYear': 'integer|min_value:1970',
    'vehicleModule.category.vehicleLoad': 'integer',
    'vehicleModule.depreciationVehicle': 'integer|min_value:1',
    parkingNodeId: ''
  },
  editVehicle: {
    'vehicleModule.licensePlate': 'required',
    'vehicleModule.price': 'integer',
    'vehicleModule.weight': 'integer',
    'vehicleModule.buyingTime': 'integer|min_value:1970',
    'vehicleModule.expiredYear': 'integer|min_value:1970',
    'vehicleModule.category.vehicleLoad': 'integer',
    'vehicleModule.depreciationVehicle': 'integer|min_value:1',
    parkingNodeId: ''
  },
  addDocumentVehicle: {
    document: 'required|fileSize:10',
    documentType: 'required',
    expiredDate: 'invalidDateFormat',
    insurancePrice: 'integer'
  },
  editDocumentVehicle: {
    document: 'fileSize:10',
    documentType: 'required',
    expiredDate: 'invalidDateFormat',
    insurancePrice: 'integer'
  }
}
export default {
  initVehicleCategory,
  initFormVehicle,
  initMaintenance,
  initTollStationPrice,
  rules
}
